export default __webpack_public_path__ + "static/media/Ellipse 15.842a156f.svg";